module.exports = __webpack_public_path__ + "static/Nick-Tune.b7fed621.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/speakers/Nick-Tune.jpg
// module id = 118
// module chunks = 18040708913748 240012292094641